<template>
<div class="">
  <div class="flex flex-col bg-white border border-gray-100 rounded-lg shadow-sm w-full px-5 sm:px-7 space-y-6 mt-4 pb-6">
      <h1 class="text-base sm:text-lg text-center text-gray-900 font-semibold border-b border-gray-100 pb-4 pt-4 lg:text-left">Send message to</h1>

      <form class="flex flex-col space-y-6">
        <div class="space-y-4">
          <div class="flex flex-col sm:flex-row sm:items-center gap-3 sm:space-x-6">
            <select class="border border-gray-200 rounded-lg h-9 px-2 text-sm focus:outline-none focus:border-express" name="to" id="">
              <option value="volvo">To</option>
              <option value="saab">All</option>
            </select>
          <!-- <label class="mr-3" for="to">To:</label> -->
          <input class="w-full sm:w-60 h-9 border rounded-lg border-gray-200 focus:border-express focus:outline-none px-3 text-sm" type="text" name="to"/>
           </div>
        <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:space-x-6">
          <label class="text-sm text-expressgray" for="title">Title:</label>
          <input class="w-full sm:w-60 h-9 border rounded-lg border-gray-200 focus:border-express focus:outline-none px-3 text-sm" type="text" name="title"/>
        </div>
        </div>

        <textarea name="message" placeholder="Type here" cols="120" rows="20"
        class="w-full border rounded-lg border-gray-200 focus:border-express focus:outline-none p-3 text-sm placeholder:italic placeholder:text-slate-500"/>

        <input class="w-full sm:w-40 h-10 bg-express hover:bg-expressbutton text-white text-sm font-medium rounded-lg transition-colors cursor-pointer" type="submit" name="SEND"/>
      </form>
  </div>
  </div>
</template>

<script>
export default {
 name: "SendMessage",
}
</script>

<style>

</style>
